var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},_vm._l((_vm.messagesArray),function(item){return _c('div',{key:_vm.messagesArray.indexOf(item)},[(_vm.showNotification)?_c('v-alert',{attrs:{"dense":"","border":"left","type":item.type,"width":"30rem"}},[_vm._v("\n      "+_vm._s(item.message)+"\n    ")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }